import React, {useState } from "react";
import './agreement.scss';

const Agreement = ({checkbox, setCheckbox}) => {
    const handleCheckboxChange = (e) => {
        setCheckbox(!checkbox)
    }
    return (
        <div style={{display: 'flex', alignItems: 'center'}}>
            <input type="checkbox" className='upload-switch-checkbox' style={{ marginRight: "8px", width: '20px'}} checked={checkbox} onChange={handleCheckboxChange} />
            <span className='upload-switch-term'>
                I have read and agree to the <a href="https://weieducation.ca/terms-conditions">terms and conditions</a>.
            </span>
        </div>
    );
}

export default Agreement